import {
  Layouts as GridLayouts,
  Layout as GridLayout
} from "react-grid-layout";

import { IDashboard } from "../api/dashboard.api";

/**
 * This helper extracts out the the users layout preferences from react grid layouts object
 */
const separateLayoutOptions = (gridLayouts: GridLayouts): { layout: IDashboard["layout"] } => {
  // Create layouts object structure
  const transformedLayout = {
    lg: [],
    md: [],
    sm: []
  };

  // Loop arrays of each layout option (lg, md, sm) and seperate out layout and widgets
  for (const screenSize in transformedLayout) {
    gridLayouts[ screenSize ].forEach((layout: GridLayout) => {
      // Create layout and record layout
      transformedLayout[ screenSize ].push({
        i: layout.i,
        x: layout.x,
        y: layout.y,
        w: layout.w,
        h: layout.h
      });
    });
  }

  return { layout: transformedLayout };
};

export default separateLayoutOptions;